import { MultiDatePicker } from 'components/MyDatePicker/MultiDatePicker';
import React, { Component, Fragment } from 'react';
import { Formik, Form, Field, FormikProps, FieldProps } from 'formik';
import { NumberOrNull, StringOrNull } from 'store/entity/types';
import Icon from 'components/Icon';
import Input from 'components/Input';
import LoadingIcon from 'components/LoadingIcon';
import { Wrapper, InputsWrapper, Action } from './styles';
import Select from '../Select';
import notify from '../Notify';
import { ISingleItemAccessToken } from 'store/tokens/tokensSlice';
import { IProviderItemView } from 'store/providers/providerTypes';
import { LimitationType } from 'store/limitations/limitationsSlice';
import i18n from '../../i18n';

interface IComponentProps {
  canUpdate: boolean;
  token?: ISingleItemAccessToken;
  onCancel?: () => void;
  item: IProviderItemView;
  onRemove: (token: ISingleItemAccessToken) => void;
  onSave: (token: ISingleItemAccessToken, isUpdate: boolean) => Promise<void>;
}

interface IComponentStates {
  editing: boolean;
  loading: boolean;
}

interface IFormValues {
  permission: StringOrNull;
  date: NumberOrNull;
}

const permissionLevels = [
  { value: 'read', label: i18n.t('read', { ns: 'documentManager' }) },
  { value: 'report', label: i18n.t('report', { ns: 'documentManager' }) },
  {
    value: 'changeData',
    label: i18n.t('changeData', { ns: 'documentManager' }),
  },
  { value: 'edit', label: i18n.t('edit', { ns: 'documentManager' }) },
];

class SingleItemAccessTokenEditor extends Component<
  IComponentProps,
  IComponentStates
> {
  state: IComponentStates = {
    editing: !this.props.token,
    loading: false,
  };

  handleChangeEditing = () => {
    this.setState((prevState) => ({ editing: !prevState.editing }));
  };

  handleCancelEditing = () => {
    if (!this.props.token && this.props.onCancel) {
      // creating
      this.props.onCancel();
    } else {
      // editing
      this.handleChangeEditing();
    }
  };

  onSubmitForm = (values: IFormValues) => {
    this.setState({ loading: true });
    const token: ISingleItemAccessToken = {
      id: this.props.token ? this.props.token.id : undefined,
      permissionLevel: values.permission as LimitationType,
      itemId: this.props.item.id,
      expirationTime: values.date,
      token: null,
    };
    if (this.props.token) {
      // updating
      this.props.onSave(token, true).then(
        () => {
          this.setState({ editing: false, loading: false });
        },
        () => {
          this.setState({ loading: false });
        }
      );
    } else {
      // creating
      this.props.onSave(token, false).then(
        () => {
          this.setState({ loading: false });
        },
        () => {
          this.setState({ loading: false });
        }
      );
    }
  };

  handleRemove = () => {
    if (this.props.token) {
      this.props.onRemove(this.props.token);
    }
  };

  handleInputChanges = (e: React.ChangeEvent<HTMLInputElement>) => {
    e.preventDefault();
  };

  render() {
    const { token, item } = this.props;
    const { editing } = this.state;
    const initialValues: IFormValues = {
      permission: token ? token.permissionLevel : 'read',
      date: token && token.expirationTime ? token.expirationTime : null,
    };

    const url =
      token &&
      token.token &&
      `https://${window.location.host}/content/${item.providerId}/direct/${token.itemId}?token=${token.token}`;

    return (
      <div>
        <Formik
          onSubmit={this.onSubmitForm}
          initialValues={initialValues}
          validateOnBlur={false}
          validateOnChange={false}
        >
          {(formikBag: FormikProps<IFormValues>) => (
            // @ts-expect-error JSX error
            <Form>
              <Wrapper>
                <InputsWrapper>
                  <div style={{ width: '20rem' }}>
                    <Field
                      name="date"
                      render={({ field }: FieldProps) => {
                        return (
                          // <APopover
                          //   arrow
                          //   curveBorder
                          //   trigger="click"
                          //   target={
                          //     <Input
                          //       {...field}
                          //       id="date"
                          //       type="text"
                          //       autoComplete="off"
                          //       required={false}
                          //       label={messages.date}
                          //       placeholder={messages.date}
                          //       onChange={this.handleInputChanges}
                          //       disabled={
                          //         (!editing && !!token) || this.state.loading
                          //       }
                          //     />
                          //   }
                          // >
                          <MultiDatePicker
                            label={
                              i18n.t('expireDate', {
                                ns: 'documentManager',
                              }) as string
                            }
                            setDate={(value) => {
                              formikBag.setFieldValue('date', value);
                            }}
                            value={field.value ?? undefined}
                            isEditable={editing}
                          />
                          // </APopover>
                        );
                      }}
                    />
                  </div>
                  {/*{editing && !this.state.loading && (
                    <Icon
                      style={{
                        alignItems: 'center',
                        marginTop: '2rem',
                        cursor: 'pointer',
                      }}
                      type="x"
                      onClick={() => formikBag.setFieldValue('date', '')}
                    />
                  )}*/}
                  <div style={{ width: '20rem' }}>
                    <Field
                      name="permission"
                      render={({ field }: FieldProps) => (
                        <Select
                          label={
                            i18n.t('permissionLevel', {
                              ns: 'documentManager',
                            }) as string
                          }
                          options={permissionLevels}
                          values={
                            field.value
                              ? [
                                  permissionLevels.find(
                                    (it) => it.value === field.value
                                  )!,
                                ]
                              : []
                          }
                          isRequired={true}
                          multiChoice={false}
                          showValues={false}
                          disabled={!editing || !!token}
                          onChangeValues={(fieldOption) => {
                            formikBag.setFieldValue(
                              field.name,
                              fieldOption[0].value
                            );
                          }}
                        />
                      )}
                    />
                  </div>
                </InputsWrapper>
                {url && (
                  <div style={{ width: '100%', display: 'flex' }}>
                    <div style={{ width: '100%' }}>
                      <Input
                        label={
                          i18n.t('url', {
                            ns: 'documentManager',
                          }) as string
                        }
                        id={token!.id + 'url'}
                        type="text"
                        value={url}
                        contentEditable={false}
                        onClick={(e) =>
                          e.currentTarget.setSelectionRange(0, url.length)
                        }
                      />
                    </div>
                    <Action
                      style={{ alignItems: 'center' }}
                      color="green"
                      onClick={() =>
                        SingleItemAccessTokenEditor.copyLinkToClipboard(url)
                      }
                    >
                      <Icon type="copy" />
                    </Action>
                  </div>
                )}
                {this.props.canUpdate && (
                  <div style={{ display: 'flex' }}>
                    {this.state.loading ? (
                      <LoadingIcon
                        customStyle={{
                          margin: '0 0.5em',
                          position: 'relative',
                        }}
                      />
                    ) : this.state.editing ? (
                      <Fragment>
                        <Action
                          color="green"
                          onClick={() => formikBag.handleSubmit()}
                        >
                          <Icon type="save" />
                        </Action>
                        <Action color="red" onClick={this.handleCancelEditing}>
                          <Icon type="x" />
                        </Action>
                      </Fragment>
                    ) : (
                      <Fragment>
                        <Action color="blue" onClick={this.handleChangeEditing}>
                          <Icon type="edit-2" />
                        </Action>
                        <Action color="red" onClick={this.handleRemove}>
                          <Icon type="trash-2" />
                        </Action>
                      </Fragment>
                    )}
                  </div>
                )}
              </Wrapper>
            </Form>
          )}
        </Formik>
      </div>
    );
  }

  private static copyLinkToClipboard(url: string) {
    navigator.clipboard.writeText(url);
    notify(
      i18n.t('linkCopiedToClipboard', {
        ns: 'documentManager',
      }) as string
    );
  }
}

export default SingleItemAccessTokenEditor;
